<p-tabView
  [activeIndex]="tab"
  (activeIndexChange)="navigate($event)"
  *ngIf="tab !== undefined"
>
  <p-tabPanel header="Recorrências">
    <ng-template pTemplate="content">
      <app-recorrencias />
    </ng-template>
  </p-tabPanel>
  <p-tabPanel header="Cobranças">
    <ng-template pTemplate="content">
      <app-cobrancas />
    </ng-template>
  </p-tabPanel>
  <p-tabPanel header="Cobranças recorrentes">
    <ng-template pTemplate="content">
      <app-cobrancas-recorrentes />
    </ng-template>
  </p-tabPanel>
  <p-tabPanel header="Webhook">
    <ng-template pTemplate="content">
      <app-webhooks />
    </ng-template>
  </p-tabPanel>
</p-tabView>
